import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers/integration.mapper';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import { Employee } from '../types/employees.types';

export function mapEmployeeFromDTO(raw: any): Employee {
  return {
    ...raw,
    connectedIntegrations: ((raw.connectedIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
    ignoredIntegrations: ((raw.ignoredIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
  };
}
